import { gql } from '@apollo/client'

export const EXPORT_EMISSION_FACTORS_QUERY = gql`
  query EmissionFactors(
    $first: Int
    $after: String
    $where: EmissionFactorsGraphQlFilterInput
    $order: [EmissionFactorsGraphQlSortInput!]
  ) {
    emissionFactors(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        productId
        productType
        productGroup
        productName
        productNameAtSource
        clickUpId
        countryId
        countryName
        regionIdentifierId
        regionStateName
        addressLine
        addressLine2
        city
        zipCode
        supplierName
        sourceLocation
        productionSystem
        plantProtectionTypeGroup
        plantProtectionType
        functionalUnit
        dataOrigin
        coreVersionRelease
        externalSource
        farmDataCalculator
        hestiaProduceId
        hestiaSubmissionId
        calculatorVersion
        pnNExcelCalculator
        mondraMAToFillMissingEutrophication
        landUse
        biodiversity
        biodiversityPDFYear
        flag_DisaggregationType
        flag_L1_LandUseChangeCarbon
        flag_L1_LandManagementCarbon
        flag_L1_LandManagementNonCarbon
        flag_L1_NonLandCarbon
        flag_L1_UnverifiedRemovalsCarbon
        flag_L1_VerifiedRemovalsCarbon
        carbon
        eutrophication
        waterUsage
        waterUsageIncludingWasterScarcity
        secondaryDataReferenceSourceType
        dataQualityReliabilityScore
        dataQualityCompletenessScore
        dataQualityComment
        referenceStudy
        referenceDataPublicationYear
        referenceRegionIdentifier
        referencesSamplingYear
        referenceTechnologyType
        referenceTechnologyProxyContribution
        referenceSourcingCountryProxyContribution
        referencesSamplingStartYear
        referenceSourcingCountry
        lastPublishedDate
        researcherName
        researcherEmail
        isVerified
        verificationComments
        verifiedByName
        verifiedByEmail
        verifiedOn
        updated
        lastUpdatedName
        userEmail
        postHarvestLossesId
        postHarvestLosses
        comment
        missingImpactFactor
        proxyCountryId
        proxyProduceId
        numberOfStudies
        numberOfCycles
        companyId
        abioticDepletion
        abioticDepletionFossilFuels
        acidification
        ecotoxicityFreshwater
        eutrophicationTerrestrial
        freshwaterEcotoxicity
        freshwaterEutrophication
        humanCarcinogenicToxicity
        humanNonCarcinogenicToxicity
        humanToxicityCancer
        humanToxicityNonCancer
        ionisingRadiation
        marineEcotoxicity
        marineEutrophication
        particulateMatter
        photochemicalOzoneFormation
        stratosphericOzoneDepletion
        terrestrialEcotoxicity
        kynetecProduceID
        landTransformation
        deforestation
        siteType
        landCover
        ghgTotal_EF_PEF_EmissionsMinusRemovals
        stationaryCombustion
        mobileCombustion
        processEmissions
        fugitiveEmissions
        landEmissions
        landManagementNetBiogenicCO2Emissions
        landManagementProductionEmissions
        biogenicProductEmissions
        inputsProduction
        carbonDioxide
        fossilCarbonDioxide
        biogenicCarbonDioxide
        methane
        fossilMethane
        biogenicMethane
        nitrousOxide
        fluorinatedGHGs
        hfCs
        pfCs
        sf6
        nf3
        scope1
        scope1_CO2
        scope1_CH4
        scope1_N2O
        scope1_HFCs
        scope1_PFCs
        scope1_SF6
        scope1_NF3
        scope2
        scope2_CO2
        scope2_CH4
        scope2_N2O
        scope2_HFCs
        scope2_PFCs
        scope2_SF6
        scope2_NF3
        scope3
        scope3_CO2
        scope3_CH4
        scope3_N2O
        scope3_HFCs
        scope3_PFCs
        scope3_SF6
        scope3_NF3
        scope3Cat1_PurchasedGoodsServices
        scope3Cat3_FuelEnergyRelatedActivities
        landManagementCO2Removals
        capturedBiogenicCO2WithGeologicStorage
        technologicalCO2RemovalsWithGeologicStorage
        outsideLSRS
        montrealProtocolSubstance_IndustrialProcesses
        montrealProtocolSubstance_InputsProduction
        otherFluorinatedGHG_IndustrialProcesses
        otherFluorinatedGHG_InputsProduction
        damageToTerrestrialEcosystems_LandOccupation
        damageToTerrestrialEcosystems_LandTransformation
        soilQualityIndex_TotalLandUseEffects
        cumulativeEnergyDemand
        cumulativeEnergyDemand_NonRenewable
        cumulativeEnergyDemand_Renewable
        abioticResourceDepletionFossilFuels
        mineralsMetalsUse
        yield
        economicValueShare
        aboveGroundCropResidueLeftOnField
        aboveGroundCropResidueRemoved
        aboveGroundCropResidueBurnt
        belowGroundCropResidue
        seed
        inorganicFertiliser_N
        inorganicFertiliser_P2O5
        inorganicFertiliser_K2O
        organicFertiliser_N
        organicFertiliser_P2O5
        organicFertiliser_K2O
        lime
        pesticide
        diesel
        electricity
        irrigation
        completenessCropResidue
        completenessElectricityFuel
        completenessFertiliser
        completenessOtherChemical
        completenessPesticideVetinaryDrug
        completenessProduct
        completenessSeed
        completenessWater
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
